document.addEventListener('alpine:init', ()=> {
    const $accordions = document.querySelectorAll('[data-accordion]')
    if (!$accordions) return

    $accordions.forEach(($accordion, accordionIndex) => {
        const $items = $accordion.querySelectorAll('[data-accordion-item]')
        if (!$items) return

        const id = 'accordion-' + accordionIndex
        const config = JSON.parse($accordion.dataset.accordion)
        const doToggle = `(window.innerWidth < 1280 ? ${config.toggleMobile} : ${config.toggle})`
        const start = Number.isInteger(config.start) ? config.start : null

        $accordion.setAttribute('x-data', `{ active: ${start} }`)

        $items.forEach(($item, itemIndex) => {
            const $trigger = $item.querySelector('[data-accordion-trigger]')
            const $content = $item.querySelector('[data-accordion-content]')
            if (!$trigger || !$content) return

            const triggerId = `${id}-${itemIndex}-trigger`
            const contentId = `${id}-${itemIndex}-content`

            $item.setAttribute('x-data', `{index: ${itemIndex}, expanded: ${start === itemIndex}}`)

            if (config.toggle || config.toggleMobile) {
                $item.setAttribute('x-init',`
                    $watch('expanded', value => { active = value && ${doToggle} ? index : active });
                    $watch('active', value => { expanded = (value === index) });
                `)
            }

            $trigger.setAttribute('id', triggerId)
            $trigger.setAttribute('aria-label', 'Toggle accordion')
            $trigger.setAttribute('aria-controls', contentId)
            $trigger.setAttribute('x-bind:aria-expanded', 'expanded')
            $trigger.setAttribute('x-on:click', `${doToggle} && ${config.forceActive} ? (expanded = true) : (expanded = !expanded)`)

            $content.setAttribute('id', contentId)
            $content.setAttribute('role', 'region')
            $content.setAttribute('aria-labelledby', triggerId)
            $content.setAttribute('x-bind:aria-hidden', '!expanded')
            $content.setAttribute('x-show', 'expanded')
            $content.setAttribute('x-collapse.duration.500ms', '')
        })
    })
})
